exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".send-cv-form .multiselect__tags{min-height:45px;padding:12px 40px 0 8px;border:1px solid #f9f9f9;background:#f9f9f9}.send-cv-form .multiselect__tags .multiselect__single{background-color:transparent}", ""]);

// exports
